export default __webpack_public_path__ + "static/media/invision.22dd8c17.svg";